import { mix, observable } from "@chorda/core";
export const BgImage = (props) => {
    return mix({
        css: 'bg-image',
        templates: {
            content: {
                css: 'bg-image-content',
                reactions: {
                    url: (v) => v && {
                        styles: {
                            backgroundImage: `url(${v})`
                        }
                    }
                }
            }
        },
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        injections: {
            url: props.url$
        },
        defaults: {
            url: () => observable(props.url)
        },
        styles: {
            width: props.width,
            height: props.height,
        },
    });
};
